import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const AlertWarning = styled.div`
  margin: 1rem 0;
  padding: 1rem 2rem;
  color: #3a87ad;
  border: 4px solid #3a87ad;
`;

export default AlertWarning;




// WEBPACK FOOTER //
// ./src/components/AlertInformation.js